export enum SortType {
  asc = 'asc',
  desc = 'desc'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}
